/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import 'babel-polyfill';

import bugsnag from 'bugsnag-js';
const bugsnagClient = bugsnag('9af39cc6be38e4d02bd155073229d2e0');

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import createPlugin from 'bugsnag-react';

import 'utils/adminHelper';
import { storage } from 'utils/storage';

import store from './store/store';

import App from './components/App/App';
import TrackPageView from './components/TrackPageView/TrackPageView';

const ErrorBoundary = bugsnagClient.use(createPlugin(React));
const rootEl = document.getElementById('root');

if (
  'ontouchstart' in window ||
  (window.DocumentTouch && document instanceof window.DocumentTouch)
) {
  document.body.classList.remove('no-touch');
  document.body.classList.add('touch');
}

if (rootEl instanceof HTMLDivElement) {
  rootEl.innerHTML = '';
}

const locale = storage.read('locale') || 'en';

/**
 * Render Application.
 */
render(
  <ErrorBoundary>
    <HelmetProvider>
      <Provider store={store}>
        <Router basename={`/${locale}`}>
          <TrackPageView>
            <App />
          </TrackPageView>
        </Router>
      </Provider>
    </HelmetProvider>
  </ErrorBoundary>,
  rootEl
);
